import React from 'react';
import { Button } from './Button';
export function Footer() {
  return <section className="flex flex-col gap-8 py-16 text-center" data-id="element-42">
      <h2 className="font-serif text-2xl md:text-3xl font-bold text-[#0F4C3A]" data-id="element-43">
        Sistema Integral de Intervención en Tartamudez, Disfluencia y Disfemia™
      </h2>

      <p className="text-xl text-stone-700 font-medium" data-id="element-44">
        Porque tu práctica profesional merece un sistema. No fichas sueltas
        buscadas en internet a las 12 de la noche.
      </p>

      <div className="flex flex-col gap-4 mt-4" data-id="element-45">
        <Button href="#compra" className="py-6 text-xl" data-id="element-46">
          QUIERO EL SISTEMA AHORA →
          <span className="text-sm font-normal opacity-90" data-id="element-47">
            $19.990 ARS · Acceso inmediato
          </span>
        </Button>
      </div>
    </section>;
}